module.exports = __webpack_public_path__ + "img/lily-qingyun.1b955771.png";